import { useEffect } from 'react';

export const useEscapeKey = onClickEsc => {
  useEffect(() => {
    if (!onClickEsc) {
      return;
    }

    const onKeyUp = event => {
      if (event.key === 'Escape') {
        onClickEsc();
      }
    };

    document.addEventListener('keyup', onKeyUp, false);

    return () => {
      document.removeEventListener('keyup', onKeyUp, false);
    };
  }, [onClickEsc]);
};
